import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as edu from "./style.module.scss";
import data from "../../data/tabsEducation.json";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabUnstyled from "@mui/base/TabUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";

export const Education = ({ accessLimited }) => {
  const [, setActive] = React.useState(0);
  return (
    <section className={edu.education}>
      <div className={main.containerMax}>
        <h2 className={main.blockTitle}>
          Как проходит обучение
        </h2>

        <TabsUnstyled defaultValue={0} selectionFollowsFocus className={`row ${edu.education_row} ${edu.wrapper}`}>
          {data.map((elem, index) => (
            <TabPanelUnstyled key={index} value={index} className={`col col-8 ${edu.education_colLeft}`}>
              {
                <div className={edu.display_wrapper}>
                  <div className={edu.display}>
                    <img
                      src={elem.image}
                      className={edu.education_colLeftBg}
                      alt="screen"
                    />
                  </div>
                  <div className={edu.display_neck}></div>
                  <div className={edu.display_footer}></div>
                </div>
              }
            </TabPanelUnstyled>
          ))}
          <TabsListUnstyled className={`col col-4 ${edu.education_colRight} ${edu.tabs}`}>
            {data.map((elem, index) => (
              <TabUnstyled key={index} className={`col ${edu.education_colRightText} ${edu.tab}`} onClick={()=>{setActive(index)}}>
                {
                  <p>
                    <span>{elem.num ? elem.num : null}</span>&nbsp;<b>{elem.title}</b> <br/>
                    {elem.text}
                  </p>
                }
              </TabUnstyled>
            ))}
            <div className={`${main.btnBlock} ${edu.btnBlock}`}>
              <a href="#cost" className={main.mainBtn}>
                Хочу на курс
              </a>
            </div>
            { accessLimited && <p style={{ margin: "0 0 30px", textAlign: "center" }}>Бесплатный доступ действителен в&nbsp;течение 7&nbsp;дней</p> }
          </TabsListUnstyled>
        </TabsUnstyled>

      </div>
    </section>
  );
};
